import { useEffect, useState } from "react"

export const useEmailCollectionPopup = (key = "lastVisit") => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const lastVisit = localStorage.getItem(key)
    const isNewUser = !lastVisit
    const isOldUser =
      lastVisit && Date.now() - Number(lastVisit) > 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds

    if (isNewUser || isOldUser) {
      setShowModal(true)
    }

    localStorage.setItem(key, String(Date.now()))
  }, [])

  return { showModal, setShowModal }
}
